<template>
  <a-drawer :title="title" width="60%" :visible="visible" :body-style="{ paddingBottom: '80px' }" @close="hide">
    <a-spin :spinning="loading">
      <div class="drawer-content">
        <a-descriptions title="基本信息" :column="2" bordered>
          <a-descriptions-item label="流水号">
            <a-tooltip :title="detailData.flowSerialNo || '--'">
              <span class="text-ellipsis">{{ detailData.flowSerialNo || '--' }}</span>
            </a-tooltip>
          </a-descriptions-item>
          <a-descriptions-item label="用户手机号">{{ detailData.userPhone || '--' }}</a-descriptions-item>
          <a-descriptions-item label="操作类型">
            <a-tag :color="detailData.flowType === 0 ? 'green' : 'red'">
              {{ detailData.flowType === 0 ? '收入' : '支出' }}
            </a-tag>
          </a-descriptions-item>
          <a-descriptions-item label="流水类型">
            <a-tag :color="getTypeColor(detailData.type)">
              {{ getTypeText(detailData.type) }}
            </a-tag>
          </a-descriptions-item>
          <a-descriptions-item label="流水来自">
            {{ getFromTypeText(detailData.fromType) }}
          </a-descriptions-item>
          <a-descriptions-item label="创建时间">{{ formatTime(detailData.createTime) || '--' }}</a-descriptions-item>
        </a-descriptions>

        <a-descriptions title="金额信息" :column="2" bordered style="margin-top: 16px">
          <a-descriptions-item label="金额">
            <span :style="{ color: detailData.flowType === 0 ? '#52c41a' : '#f5222d', fontSize: '16px', fontWeight: 'bold' }">
              {{ detailData.flowType === 0 ? '+' : '-' }}¥{{ detailData.flowMoney || 0 }}
            </span>
          </a-descriptions-item>
          <a-descriptions-item label="操作前金额">¥{{ detailData.flowBeforeOperationMoney || 0 }}</a-descriptions-item>
          <a-descriptions-item label="操作后金额">¥{{ detailData.flowAfterOperationMoney || 0 }}</a-descriptions-item>
        </a-descriptions>

        <a-descriptions title="其他信息" :column="2" bordered style="margin-top: 16px">
          <a-descriptions-item label="用户ID">{{ detailData.userId || '--' }}</a-descriptions-item>
          <a-descriptions-item label="对象ID">{{ detailData.objId || '--' }}</a-descriptions-item>
        </a-descriptions>

        <a-descriptions title="备注信息" :column="1" bordered style="margin-top: 16px" v-if="detailData.flowExplain">
          <a-descriptions-item label="备注说明">{{ detailData.flowExplain || '无备注' }}</a-descriptions-item>
        </a-descriptions>
      </div>
    </a-spin>

    <div class="drawer-footer">
      <a-button @click="hide">关闭</a-button>
    </div>
  </a-drawer>
</template>

<script>
import { getFlowDetail } from '@/api/pressure/fund'
import { message } from 'ant-design-vue'

export default {
  name: 'FundFlowDetailDrawer',
  data() {
    return {
      visible: false,
      loading: false,
      detailData: {},
    }
  },
  computed: {
    title() {
      return '资金流水详情'
    },
  },
  methods: {
    init(record) {
      this.visible = true
      if (record && record.id) {
        this.loadDetail(record.id)
      } else {
        this.detailData = {}
      }
    },
    hide() {
      this.visible = false
      this.detailData = {}
    },
    async loadDetail(id) {
      this.loading = true
      try {
        const response = await getFlowDetail(id)
        if (response && response.data) {
          this.detailData = response.data
        } else {
          message.error('获取详情失败')
        }
      } catch (error) {
        console.error('获取详情失败:', error)
        message.error('获取详情失败')
      } finally {
        this.loading = false
      }
    },
    formatTime(time) {
      if (!time) return '--'
      return time
    },
    getTypeText(type) {
      const map = {
        0: '积分',
        1: '余额',
        2: '押金',
        3: '微信',
        4: '支付宝',
      }
      return map[type] || '未知'
    },
    getTypeColor(type) {
      const map = {
        0: 'blue',
        1: 'green',
        2: 'orange',
        3: 'cyan',
        4: 'purple',
      }
      return map[type] || 'gray'
    },
    getFromTypeText(fromType) {
      const map = {
        0: '订单',
        1: '提现',
        2: '充值',
        3: '退款',
        4: '人工',
      }
      return map[fromType] || '未知'
    },
  },
}
</script>

<style scoped>
.drawer-content {
  padding: 0;
}

.drawer-footer {
  position: absolute;
  right: 0;
  bottom: 0;
  width: 100%;
  border-top: 1px solid #e9e9e9;
  padding: 10px 16px;
  background: #fff;
  text-align: right;
  z-index: 1;
}

.ant-descriptions {
  margin-bottom: 0;
}

.text-ellipsis {
  display: inline-block;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>

